import React from 'react';
import { AdminLayout } from '../../components/layout/AdminLayout';
import { useTenant } from '../../lib/tenant-context';
import { useLoyaltyDashboard } from '../../lib/loyalty-hooks';
import { Card } from '../../components/ui/Card';
import { Users, Star, Gift, Trophy } from 'lucide-react';
import { formatCurrency } from '../../lib/utils';
export function LoyaltyDashboardPage() {
  const {
    restaurant,
    role,
    signOut
  } = useTenant();
  const {
    customers,
    loading
  } = useLoyaltyDashboard(restaurant.restaurant_id);
  const totalCustomers = customers.length;
  const totalPoints = customers.reduce((sum, c) => sum + (c.current_points || 0), 0);
  const totalRewardsAvailable = customers.reduce((sum, c) => sum + (c.available_rewards_count || 0), 0);
  const totalRewardsRedeemed = customers.reduce((sum, c) => sum + (c.redeemed_rewards_count || 0), 0);
  return <AdminLayout restaurant={restaurant} role={role} onSignOut={signOut} data-id="element-3378">
      <div className="p-6 max-w-7xl mx-auto space-y-6" data-id="element-3379">
        <div data-id="element-3380">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-3381">
            Programa de Lealtad
          </h1>
          <p className="text-gray-500" data-id="element-3382">
            Gestiona tus clientes frecuentes y beneficios
          </p>
        </div>

        {/* KPIs */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-3383">
          <Card className="p-6" data-id="element-3384">
            <div className="flex items-center gap-4" data-id="element-3385">
              <div className="w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-3386">
                <Users className="w-6 h-6 text-blue-600" data-id="element-3387" />
              </div>
              <div data-id="element-3388">
                <p className="text-sm text-gray-500 font-medium" data-id="element-3389">
                  Clientes Leales
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-3390">
                  {totalCustomers}
                </p>
              </div>
            </div>
          </Card>
          <Card className="p-6" data-id="element-3391">
            <div className="flex items-center gap-4" data-id="element-3392">
              <div className="w-12 h-12 bg-yellow-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-3393">
                <Star className="w-6 h-6 text-yellow-600" data-id="element-3394" />
              </div>
              <div data-id="element-3395">
                <p className="text-sm text-gray-500 font-medium" data-id="element-3396">
                  Puntos Emitidos
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-3397">
                  {totalPoints}
                </p>
              </div>
            </div>
          </Card>
          <Card className="p-6" data-id="element-3398">
            <div className="flex items-center gap-4" data-id="element-3399">
              <div className="w-12 h-12 bg-green-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-3400">
                <Gift className="w-6 h-6 text-green-600" data-id="element-3401" />
              </div>
              <div data-id="element-3402">
                <p className="text-sm text-gray-500 font-medium" data-id="element-3403">
                  Beneficios Disponibles
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-3404">
                  {totalRewardsAvailable}
                </p>
              </div>
            </div>
          </Card>
          <Card className="p-6" data-id="element-3405">
            <div className="flex items-center gap-4" data-id="element-3406">
              <div className="w-12 h-12 bg-purple-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-3407">
                <Trophy className="w-6 h-6 text-purple-600" data-id="element-3408" />
              </div>
              <div data-id="element-3409">
                <p className="text-sm text-gray-500 font-medium" data-id="element-3410">
                  Beneficios Redimidos
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-3411">
                  {totalRewardsRedeemed}
                </p>
              </div>
            </div>
          </Card>
        </div>

        {/* Customer Table */}
        <Card className="overflow-hidden" data-id="element-3412">
          <div className="p-6 border-b border-gray-200" data-id="element-3413">
            <h2 className="font-bold text-gray-900" data-id="element-3414">Directorio de Clientes</h2>
          </div>
          <div className="overflow-x-auto" data-id="element-3415">
            <table className="w-full text-left text-sm" data-id="element-3416">
              <thead className="bg-gray-50 text-gray-500" data-id="element-3417">
                <tr data-id="element-3418">
                  <th className="px-6 py-4 font-medium" data-id="element-3419">Cliente</th>
                  <th className="px-6 py-4 font-medium" data-id="element-3420">Teléfono</th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-3421">Visitas</th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-3422">
                    Total Gastado
                  </th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-3423">
                    Ticket Promedio
                  </th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-3424">Puntos</th>
                  <th className="px-6 py-4 font-medium" data-id="element-3425">Nivel</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200" data-id="element-3426">
                {loading ? <tr data-id="element-3427">
                    <td colSpan={7} className="px-6 py-8 text-center text-gray-500" data-id="element-3428">
                      Cargando clientes...
                    </td>
                  </tr> : customers.length === 0 ? <tr data-id="element-3429">
                    <td colSpan={7} className="px-6 py-8 text-center text-gray-500" data-id="element-3430">
                      No hay clientes registrados aún.
                    </td>
                  </tr> : customers.map(customer => <tr key={customer.customer_id} className="hover:bg-gray-50" data-id="element-3431">
                      <td className="px-6 py-4 font-medium text-gray-900" data-id="element-3432">
                        {customer.name || 'Sin nombre'}
                      </td>
                      <td className="px-6 py-4 text-gray-500" data-id="element-3433">
                        {customer.phone}
                      </td>
                      <td className="px-6 py-4 text-right text-gray-900" data-id="element-3434">
                        {customer.total_orders}
                      </td>
                      <td className="px-6 py-4 text-right text-gray-900" data-id="element-3435">
                        {formatCurrency(customer.total_spent, restaurant.currency_symbol)}
                      </td>
                      <td className="px-6 py-4 text-right text-gray-500" data-id="element-3436">
                        {formatCurrency(customer.total_spent / Math.max(1, customer.total_orders), restaurant.currency_symbol)}
                      </td>
                      <td className="px-6 py-4 text-right font-bold text-brand-charcoal" data-id="element-3437">
                        {customer.current_points}
                      </td>
                      <td className="px-6 py-4" data-id="element-3438">
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-3439">
                          {customer.current_level || 'Inicial'}
                        </span>
                      </td>
                    </tr>)}
              </tbody>
            </table>
          </div>
        </Card>
      </div>
    </AdminLayout>;
}